class Brightcache<GenericType> {
    private cache: Map<string, { value: GenericType; expiresAt: number }> = new Map();

    get(key: string): GenericType | null {
        const cachedItem = this.cache.get(key);
        if (cachedItem && cachedItem.expiresAt > Date.now()) {
            return cachedItem.value;
        }
        return null; // Cache miss or expired
    }

    set(key: string, value: GenericType, ttl: number = 0): void {
        const expiresAt = ttl === 0 ? Infinity : Date.now() + ttl * 1000; // ttl in seconds
        this.cache.set(key, { value, expiresAt });
    }

    delete(key: string): void {
        this.cache.delete(key);
    }

    flush(): void {
        this.cache.clear();
    }
}

export default Brightcache;
